import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Landing from '../views/Landing.vue';
import SignUp from '../views/SignUp.vue';
import ConfirmOrder from '../views/ConfirmOrder.vue';
import SignUpOld from '../views/SignUpOld.vue';
import Legal from '../views/Legal.vue';
import Legacy from '../views/Legacy.vue';
import AboutUs from '../views/AboutUs.vue';
import Outage from '../views/Outage.vue';
import Confirm from '../views/Confirm.vue';
import Authentication from '../views/Authentication.vue';
import NotFound from '../views/NotFound.vue';
import NotServiceable from '../views/NotServiceable.vue';
import CsgWaiverScript from '../views/CsgWaiverScript.vue';
import Redirect from '../views/Redirect.vue';
import Redirect2 from '../views/Redirect2.vue';
import Complaints from '@/views/Complaints.vue';
import App from '@/App.vue';
import Dfsv from '@/views/Dfsv.vue';

// Here is where we map routes to pages. A page is defined as a
// Vue component in the '@/views/...' directory.
const routes: Array<RouteRecordRaw> = [
  { path: '/', name: 'landing', component: Landing },
  { path: '/sign-up', name: 'sign-up', component: SignUp },
  { path: '/confirm-order', name: 'confirm-order', component: ConfirmOrder },
  { path: '/sign-up-his', name: 'sign-up-his', component: SignUpOld },
  { path: '/legal', name: 'legal', component: Legal },
  { path: '/legacy', name: 'legacy', component: Legacy },
  { path: '/about-us', name: 'about-us', component: AboutUs },
  { path: '/outage', name: 'outage', component: Outage },
  { path: '/dfsv', name: 'dfsv', component: Dfsv },
  { path: '/confirm', name: 'confirm', component: Confirm },
  { path: '/not-serviceable', name: 'not-serviceable', component: NotServiceable },
  { path: '/authentication', name: 'authentication', component: Authentication },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
  { path: '/csg-waiver-script', name: 'csg-waiver-script', component: CsgWaiverScript },
  { path: '/uniti', name: 'redirect', component: Redirect },
  { path: '/nexee', name: 'redirect2', component: Redirect2 },
  { path: '/complaints', name: 'complaints', component: Complaints },
  {
    path: '/csa',
    name: 'csa',
    component: Legal,
    beforeEnter () {
      window.location.href = `https://uniti-bpo-website-assets.assets.unitiinternet.com/${process.env.VUE_APP_BRAND_CODE}/customer-service-agreement.pdf`;
      return false;
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy',
    component: Legal,
    beforeEnter () {
      window.location.href = `https://uniti-bpo-website-assets.assets.unitiinternet.com/${process.env.VUE_APP_BRAND_CODE}/privacy-policy.pdf`;
      return false;
    }
  },
  {
    path: '/family-violence',
    name: 'family',
    component: App,
    beforeEnter () {
      window.location.href = `https://uniti-bpo-website-assets.assets.unitiinternet.com/${process.env.VUE_APP_BRAND_CODE}/family-domestic-sexual-violence-support.pdf`;
      return false;
    }
  }
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      // Has a hash that is not part of Microsoft authentication.
      if (to.hash && to.hash.indexOf('#code=') === -1) {
        return { el: to.hash, behavior: 'smooth' };
      }
      // Only the query changed (e.g. ?id= added on /confirm-order), so stay put.
      if (to.path === from.path) {
        return false;
      }
      return { left: 0, top: 0 };
    }
  }
});

export default router;
